<template>
  <div class="file-upload__item glue-v">
    <img v-if="file.thumb" :src="file.thumb" class="thumb" />
    <div v-else class="px-6 py-3 bg-purple-400 text-white rounded shadow-lg">
      {{ file.file.name }}
    </div>
    <div
      v-if="file.storing && file.progress < 100"
      class="relative w-full h-2 rounded bg-gray-400 overflow-hidden"
    >
      <div
        :style="{ width: `${file.progress}%` }"
        class="absolute top-0 bottom-0 left-0 bg-indigo-500"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUploadItem',
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="postcss" scoped>
.file-upload__item {
  @apply w-full;
}
.file-upload__item + .file-upload__item {
  @apply mt-4;
}
.thumb {
  @apply rounded block;
}
</style>
